export const getTextWithoutBrackets = (text: string): string =>
  text.replace(/\{\{(.+?)\}\}/g, '')
